import React, { Component } from 'react'
import { PageContainerLayout, PageHeaderLayout } from '../../../layouts'
import { NavLink } from 'react-router-dom'
import * as ROUTING_PATHS from '../../../../routing/Paths'
import { JobsPoolsWizardForm } from '../../containers'
import { Session } from '../../../../state/utils/session'

class JobsPoolsCreatorPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      session: new Session()
    }

    this.renderHeaderPaths = this.renderHeaderPaths.bind(this)
  }

  renderHeaderPaths () {
    return (
            <>
                <li>
                    <NavLink className="link-effect"
                             to={ROUTING_PATHS.CLIENT_DASHBOARD_JOB_POOLS_PATH.replace(':client_id', this.state.session.getClientSession())}>
                        Jobs Pools
                    </NavLink>
                </li>
                <li>New Job Pool</li>
            </>
    )
  }

  render () {
    return (
            <>

                <PageContainerLayout clientSidebar={true} showNavbarClientOptions={true}>
                    <PageHeaderLayout
                        title={'New Job Pool'}
                        subTitle={'Create a new Job Pool'}
                        paths={this.renderHeaderPaths}
                    />
                    <JobsPoolsWizardForm/>
                </PageContainerLayout>
            </>
    )
  }
}

export { JobsPoolsCreatorPage }
